@if (showNotice()) {
    <div class="alert alert-warning d-flex ms-icon-text gap-2" role="alert">
        <fa-duotone-icon icon="circle-info" secondaryOpacity="0.4" />
        <!-- The charge-schedule form suppresses every Enter keydown that reaches it, which would
             cancel the browser's activation of this link. Keep the keypress away from the host. -->
        <div><strong>Note: </strong>{{ messageBeforeLink() }}<a class="alert-message-link"
                [routerLink]="settingsRoute()"
                [queryParams]="settingsQueryParams"
                (keydown.enter)="$event.stopPropagation()">{{ linkText }}</a>{{ messageAfterLink() }}</div>
    </div>
}
